// @flow
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import styled from 'styled-components';
import { ICONS } from '../../../../icons/Icons';
import Icon from '../../../../icons/Icon';
import colors from '../../../../utils/colors';

const propTypes = {
  handlePrev: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  currentMonth: PropTypes.instanceOf(moment).isRequired,
};

const defaultProps = {};

const StyledTitleBlock = styled.div`
  background: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 2.5rem;
  text-transform: capitalize;
`;

const StyledTitle = styled.span`
  flex: 1;
  text-align: center;
`;

const StyledWeekDaysHeader = styled.ul`
  background: white;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-weight: 400;
  line-height: 2rem;
  text-transform: capitalize;

  li {
    flex: 1 0;
    text-align: center;
  }
`;

const StyledButton = styled.button`
  background: transparent;
  padding: 0 .5rem;
  line-height: 0;
  color: #424242;

  svg {
    width: 1.625rem;
    height: 1.625rem;
    stroke: ${colors.BRAND_RED};
  }

  &[disabled] {
    svg {
      stroke: ${colors.GRAY_LIGHT};
    }
  }
`;

const Header = (props:Object) => {
  const prevDisabled = props.prevDisabled;//props.currentMonth.clone().subtract(1, 'month').isBefore(thisMonth, 'month');
  const nextDisabled = props.nextDisabled;//props.currentMonth.clone().add(1, 'month').isAfter(thisMonth, 'month');
  const weekDays = moment.weekdaysShort(true);
  return (
    <header>
      <StyledTitleBlock>
        <StyledButton onClick={props.handlePrev} disabled={prevDisabled}>
          <Icon icon={ICONS.CHEVRON_LEFT} />
        </StyledButton>
        <StyledTitle>{props.currentMonth.format('MMMM YYYY')}</StyledTitle>
        <StyledButton onClick={props.handleNext} disabled={nextDisabled}>
          <Icon icon={ICONS.CHEVRON_RIGHT} />
        </StyledButton>
      </StyledTitleBlock>
      <StyledWeekDaysHeader>
        {weekDays.map((day, i) =>
          <li key={i}>{day}</li>
        )}
      </StyledWeekDaysHeader>
    </header>
  );
};

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;


// WEBPACK FOOTER //
// ./src/modules/common/components/calendar/Header.js